import { Route, Routes } from "react-router-dom";
import HomePage from "../../pages/home/home-page";
import { ACCESS_RULES } from "../../shared/auth/access-control";
import RoleProtectedRoute from "../protected/role-protected-route.component";

const HomeRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<RoleProtectedRoute allowedRoles={ACCESS_RULES.HOME}><HomePage /></RoleProtectedRoute>} />
    </Routes>
  );
};

export default HomeRoutes;
